type QuoteItemGroupProps = {
  label: string | React.ReactNode
  value?: string
  items: React.ReactElement[]
} & React.HTMLAttributes<HTMLLIElement>

export function QuoteItemGroup({ label, value, items }: QuoteItemGroupProps) {
  const currencyAndAmount = value?.split(" ")

  return (
    <li className="mb-2 flex flex-col justify-between rounded-md border-b py-1 pb-2 last:border-b-0">
      <div className="flex justify-between">
        <div className="pb-2 font-semibold">{label}</div>
        {currencyAndAmount && (
          <div className="text-sm">
            <span className="font-semibold">{currencyAndAmount[0]}</span>
            <span className="ml-1">{currencyAndAmount[1]}</span>
          </div>
        )}
      </div>
      <div className="">
        <ul>{items}</ul>
      </div>
    </li>
  )
}
